// extracted by mini-css-extract-plugin
export default {"prevent-overflow":"EstimatesList_prevent-overflow__40UMA"};